import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuardService } from '@xpo/security';
import { AuthorizationGuard } from '../core/index';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SignedoutComponent } from './signedout/signedout.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/dashboard',
      },
      { path: 'dashboard', component: DashboardComponent, canActivate: [AuthorizationGuard] },
      { path: 'signedout', component: SignedoutComponent },
      {
        path: 'applications',
        loadChildren: 'application.bloc/app.module#ApplicationBlocModule',
        canActivate: [AuthorizationGuard],
        data: {
          permissions: ['applications'],
        },
      },
      {
        path: 'services',
        loadChildren: 'service.bloc/service.module#ServiceBlocModule',
        canActivate: [AuthorizationGuard],
        data: {
          permissions: ['applications'],
        },
      },
      {
        path: 'users',
        loadChildren: 'users.bloc/users.module#UsersBlocModule',
        canActivate: [AuthorizationGuard],
        data: {
          permissions: ['applications', 'identity-providers'],
        },
      },
      {
        path: 'vendors',
        loadChildren: 'vendor.bloc/vendor.module#VendorBlocModule',
        canActivate: [AuthorizationGuard],
        data: {
          permissions: ['vendor-integration'],
        },
      },
      {
        path: 'ip',
        loadChildren: 'ip.bloc/ip.module#IPBlocModule',
        canActivate: [AuthorizationGuard],
        data: {
          permissions: ['identity-providers'],
        },
      },
      // {path: '**', redirectTo: '/pagenotfound'}
    ]),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routes.ts